import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/store';
import HomePage from './components/home/home'
import LoginPage from './components/auth/login'
import OrganizationEmployees from './components/employees/organizationEmployees'
import Users from './components/users/users'
import UserOrganizations from './components/users/userOrganizations'
import Organizations from './components/organizations/organizations'
import Organization from './components/organizations/organizationView'
import Structures from './components/structures/structures';
import Structure from './components/structures/structureView'
import Contracts from './components/contracts/contracts';
import Contract from './components/contracts/contractView';
import Vacations from './components/vacations/vacationsIndex';
import StructureVacations from './components/vacations/structureVacations';
import OrganizationVacations from './components/vacations/organizationVacations';
import Attendances from './components/attendance/attendances';
import AttendancesIndex from './components/attendance/attendancesIndex';
import KidAttendanceRecords from './components/contracts/kidAttendances';
import Payments from './components/payments/payments'
import apiLogging from './components/adminTools/apiLogging'
import userLogging from './components/adminTools/userLogging'
import AdminToolsIndex from './components/adminTools/adminToolsIndex'
import ParametersIndex from './components/parameters/parametersIndex'
import AbsenceReasons from './components/parameters/absenceReasons'
import UnlockReasons from './components/parameters/unlockReasons'
import UserView from './components/users/userView'
import ConfirmationEmail from './components/Email/confirmationEmail';
import Holidays from './components/parameters/holidays'
import GlobalParams from './components/parameters/globalParams'
import SecurityRules from './components/parameters/securityRules'
import Documents from './components/parameters/documents'
import Mobiles from './components/mobiles/mobiles';
import VerificationsIndex from './components/verifications/verificationsIndex';
import TermsOfUse from "./components/topics/termsofuse";
import PrivacyPolicy from "./components/topics/privacyPolicy";
import VerifyAttendances from "./components/verifications/verifyAttendances";
import Versions from "./components/adminTools/versions";
import Actions from "./components/parameters/actions";
import AuthApps from "./components/auth/authApps.vue";
import AnnouncementsIndex from "./components/announcements/Index.vue";
import AnnouncementCreate from "./components/announcements/Create.vue";
import AnnouncementDetails from "./components/announcements/Details.vue";
import AnnouncementEdit from "./components/announcements/Edit.vue";
import VerificationsOtpValidUntil from "./components/adminTools/verificationsOtpValidUntil";

Vue.use(VueRouter);

const routes = [
  {
    path: '/', component: LoginPage, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next('Home');
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/Home', component: HomePage, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/login', component: LoginPage, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (!store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/home');
      }
    }
  },
  { path: '/login/taxis', component: LoginPage, props: route => ({ jwt: route.query.jwt }) },
  {
    path: '/organizationEmployees', component: OrganizationEmployees, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/organizations', component: Organizations, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated && (store.getters.isSuperAdmin || store.getters.isAdmin)) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/organization/:oId', component: Organization, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/users', component: Users, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated && (store.getters.isSuperAdmin || store.getters.isAdmin)) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/user', component: UserView, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },

  {
    path: '/userOrganizations/:uId/:uName', component: UserOrganizations, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated && store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/structures', component: Structures, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/structure/:sId', component: Structure, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/mobiles', component: Mobiles, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/contracts', component: Contracts, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/contract/:cId', component: Contract, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/kidAttendanceRecords/:cId', component: KidAttendanceRecords, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/vacations', component: Vacations, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/structureVacations', component: StructureVacations, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/organizationVacations', component: OrganizationVacations, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/attendances', component: AttendancesIndex, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/attendancesdetails/:sId/:dDate', component: Attendances, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/payments', component: Payments, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/adminTools', component: AdminToolsIndex, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/apiLogging', component: apiLogging, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/userLogging', component: userLogging, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/versions', component: Versions, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/verificationsOtpValidUntil', component: VerificationsOtpValidUntil, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/parameters', component: ParametersIndex, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/absenceReasons', component: AbsenceReasons, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/unlockReasons', component: UnlockReasons, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/confirmationEmail/:a/:b', component: ConfirmationEmail, props: true, beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: '/holidays', component: Holidays, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/globalParams', component: GlobalParams, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/securityRules', component: SecurityRules, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/documents', component: Documents, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/verfications', component: VerificationsIndex, props: true, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/termsofuse', component: TermsOfUse, props: true, beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: '/privacy-policy', component: PrivacyPolicy, props: true, beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: '/verify-attendances', component: VerifyAttendances, props: true, beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: '/actions', component: Actions, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isSuperAdmin) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/authenticateApps', component: AuthApps, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/Announcements/Index', component: AnnouncementsIndex, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/Announcements/Create', component: AnnouncementCreate, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated && (store.getters.isSuperAdmin || store.getters.isAdmin)) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/Announcements/Details/:Id', component: AnnouncementDetails, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },
  {
    path: '/Announcements/Edit/:Id', component: AnnouncementEdit, beforeEnter: (to, from, next) => {
      store.dispatch('tryAutoLogin');

      if (store.getters.isAuthenticated && (store.getters.isSuperAdmin || store.getters.isAdmin)) {
        next();
      }
      else {
        store.dispatch('logout');
        next('/login');
      }
    }
  },

];

export default new VueRouter({ mode: 'history', routes });